import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import { ShiftsIcon } from '@atoms/icons';
import { EmptyListPlaceholder } from '@molecules/dataDisplay';
import { DataGrid } from '@molecules/dataDisplay';
import { useAgencyTypesSettingsColumns } from './columns';
import { useAgencyTypesListFilterStore } from '@libs/store/agencyTypes/listFiltersStore';
import { AgencyTypeListItem } from '@libs/models/agencies';

type StaffingPartnersListPageProps = {
  loading: boolean;
  rows: AgencyTypeListItem[];
  localizationSubset: string;
};
export function AgencyTypesTable({ loading, rows, localizationSubset }: StaffingPartnersListPageProps) {
  const { activeFilters } = useAgencyTypesListFilterStore();
  const search = activeFilters.find((f) => f.key === 'search')?.value;

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={rows}
        loading={loading}
        rowHeight={64}
        columns={useAgencyTypesSettingsColumns({
          localizationSubset,
        })}
        hideFooter
        filterModel={{
          items: [{ field: 'name', operator: 'contains', value: search }],
        }}
        disableRowSelectionOnClick
        noRowsOverlay={
          <EmptyListPlaceholder
            icon={<ShiftsIcon active />}
            title={<FormattedMessage id={`${localizationSubset}.table.noRows.title`} />}
            subtitle={<FormattedMessage id={`${localizationSubset}.table.noRows.subtitle`} />}
          />
        }
      />
    </Box>
  );
}
